import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

import { GAMES } from '../config';

var appStateKey = '.app__initial-state';

var StateModel = Backbone.Model.extend({
  defaults: function () {
    return {
      env: '',
      game: null,
      gameName: '',
      nickname: '',
      ssn: 0,
      gameInfoSrl: 0,
      msn: 0,
      usn: 0,
      gsn: 0,
      adult: false,
      guest: false,
      loginUrl: '',
      loggedIn: false,
      membership: null,
      membershipRemaining: null,
      channelling: null,
      mfaServiceType: null,
      mfaDeprecated: null,
      mfaActivated: null,
      maintenance: null,
      maintenanceMessage: '',
      revision: '',
      requestId: ''
    };
  },

  initialize: function () {
    this.fetch();
  },

  setGame: function (game) {
    var switchingGame = GAMES[game];

    this.save({
      game: game,
      gameName: switchingGame.name,
      ssn: switchingGame.ssn,
      gameInfoSrl: switchingGame.gameInfoSrl,
      msn: switchingGame.msn
    });
  },

  checkMFAActivated: function () {
    return this.get('mfaActivated');
  },

  checkMFADeprecated: function () {
    return this.get('mfaDeprecated') && this.checkMFAActivated();
  },

  authenticateMFA: function (isPassed) {
    this.save({ mfaActivated: !isPassed });
  },

  sync: function (method, model) {
    var initialState;
    var savingState;
    var $state = $(appStateKey);

    if (method === 'create' || method === 'update') {
      savingState = _.clone(model.attributes);
      $state.data(savingState);
    } else if (method === 'read') {
      initialState = $state.eq(0).data();
      model.set(initialState);
    }
  }
});

export var state = new StateModel();
